import { ConditionalValue } from "@chakra-ui/react"
import { JSX } from "react"

export type ImageInfo = {
    href: string,
    title: string
}

export type EventInfo = {
    event_id: string,
    name: string,
    start_time: string,
    end_time: string,
    date: string,
    location: string,
    short_description: string,
    long_description: string,
    need_supplies: boolean
}

export type TabInfo = {
    title: string,
    route: string
}

export enum UserRole {
    Administrator,
    Staff,
    Approved,
    Registered,
    Banned
}

export type UserInfo = {
    telegram_id: string
    username: string,
    name: string, 
    email: string,
    role: string,

}

export type DropdownAction = {
    option: string,
    function: any
}

export type StaffInfo = {
    name: string,
    image: string,
    description: string
}

export type PotluckItemInfo = {
    name: string,
    description: string,
    item_id: string,
    limited_quantity: boolean,
    sold_by: SoldByType
}

export type PotluckItemRequest = {
    item_id: string,
    quantity: number
}

export type PotluckItemContribution = {
    item_id: string, // corresponds to the food item, not this item
    user_id: string,
    user_description: string,
    quantity_provided: number
}

export type PotluckItemInfoAndRequest = {
    info: PotluckItemInfo,
    request: PotluckItemRequest
}

export type PotluckItemInfoAndContribution = {
    info: PotluckItemInfo,
    contribution: PotluckItemContribution
}


export type SoldByType = "each" | "package"

export type WishlistItemProps = {
    item: PotluckItemInfo
}


// types used for prop components
export type TabsComponentProps = {
    labels: string[],
    variant: ConditionalValue<"outline" | "line" | "subtle" | "enclosed" | "plain" | undefined>,
}

export type ChildComponent = {
    index: number,
    child: JSX.Element
}

export type ListBoxComponentProps = {
    itemListType: ListComponentItemType.UserInfo | ListComponentItemType.EventInfo,
    itemList: UserInfo[] | EventInfo[],
    onValueChange: (details: any) => void
}

export type CollectionItem = {
    label: string,
    value: string
}

export type UserDisplayComponentProps = {
    user: UserInfo
}

export type EventDisplayComponentProps = {
    event: EventInfo
}

export enum ListComponentItemType {
    UserInfo,
    EventInfo
}

export type ListComponentProps = {
    itemType: ListComponentItemType
}